import { CloudApi } from "@/v2/infraestructure/api/cloudapi";
import { useUserStore } from "@/v2/application/stores/userStore";

export const loginCase = async (username, password) => {
    const userStore = useUserStore();
    const cloudApi = new CloudApi();
    try {
        const response = await cloudApi.login(username, password);
        if (response.code == 0) {
            userStore.setUsername(username);
            userStore.setPassword(password);
            userStore.setToken(response.data.access_token);
            userStore.setUserId(response.data.user_id);
            userStore.setWorkspaceId(response.data.workspace_id);
            console.log("Login successful, user store updated.");
            console.log("User ID:", userStore.getUserId());
            console.log("Workspace ID:", userStore.getWorkspaceId());
            console.log("Token:", userStore.getToken());
            console.log("Username:", userStore.getUsername());
            return true;
        } else {    
            return false;
        }
    } catch (error) {
        console.error("Error during login:", error);
        return false;
    }
}
